<template>
    <section v-if="false" :class="shit$(`fixed; top:0px; left:50%; z:2001;`)">
        <message-item />
        <div :class="shit$(``)"></div>
    </section>
</template>

<script>
import MessageItem from "@/code-lab/view/organization/message.vue"
export default {
    components: {
        MessageItem
    }
}
</script>
